common.View.create('shop::Habitats.Website.Modules.ShopCheckout.Order.Address', {

    onDOMLoad() {
        this.initRequiredForInvoiceType();
        this.initAddressLookup();
    },

    initRequiredForInvoiceType() {
        // Abort due to not invoice type?
        if (this.element.data('type') !== 'invoice') {
            return;
        }

        this.element

            // Store for each input if it is/was required.
            .find('*[required]')
            .each((i, element) => $(element).attr('data-required', $(element).is('[required]')))
            .end();
    },

    manageRequiredInvoiceType(invoiceActive) {
        // Abort due to not invoice type?
        if (this.element.data('type') !== 'invoice') {
            return;
        }

        this.element

            // Hide or show?
            .toggleClass('tw-hidden', !invoiceActive)

            // Set inputs as required if they were + invoice type is active.
            .find('*[data-required]')
            .each((i, element) => $(element).attr('required', invoiceActive && $(element).data('required')))
            .end();
    },

    initAddressLookup() {

        this.element

            .find('select[name*="country"')
                .change(event => {

                    if($(event.currentTarget).val() === 'NL') {

                        this.element

                            .find('.address-manually')
                                .addClass('tw-hidden').end()
                            .find('input[name*="postal"]')
                                .trigger('change');

                    } else {

                        this.element

                            .find('.address-textual')
                                .addClass('tw-hidden').end()
                            .find('.address-manually')
                                .removeClass('tw-hidden');

                    }

                })
                .trigger('change')
                .end()

            .find('input[name*="postal"], input[name*="house_number"], input[name*="house_number_addition"]').change(event => {

                let zipcode = this.element.find('input[name*="postal"]').val();
                let houseNumber = this.element.find('input[name*="house_number"]').val();
                let houseNumberAddition = this.element.find('input[name*="house_number_addition"]').val();
                let country = this.element.find('select[name*="country"').val();

                if(zipcode && houseNumber && country === 'NL') {
                    this.doAddressLookup(zipcode, houseNumber, houseNumberAddition);
                }

            }).end()

            .find('.change-address-manually').click(event => {

                this.element

                    .find('.address-textual')
                        .addClass('tw-hidden').end()
                    .find('.address-manually')
                        .removeClass('tw-hidden');

            }).end()

            .find('input[name*="country"]')
                .trigger('change')
                .end()

            .find('input[name*="postal"]')
                .trigger('change')
                .end()




    },

    async doAddressLookup(zipcode, houseNumber, houseNumberAddition) {

        this.showLoader();

        let response = await $.post(this.element.data('url') + '/address-lookup', {
            zipcode: zipcode,
            houseNumber: houseNumber,
            houseNumberAddition: houseNumberAddition
        });

        // Show or hide address based on response.
        this.parseResponse(response);


        this.hideLoader();
    },

    parseResponse(data) {

        if(data) {
            // Address found.
            this.element

                .find('input[name*="city"]')
                    .val(data.city).end()
                .find('input[name*="street"]')
                    .val(data.street).end()

                .find('.address-manually')
                    .addClass('tw-hidden')
                .find('.not-found-message')
                    .addClass('tw-hidden').end().end()

                .find('.address-textual')
                    .removeClass('tw-hidden')

                    .find('.street')
                        .text(data.street).end()
                    .find('.house-number')
                        .text(data.houseNumber).end()
                    .find('.house-number-addition')
                        .text(data.houseNumberAddition).end()

                    .find('.zipcode')
                        .text(data.postcode).end()
                    .find('.city')
                        .text(data.city).end().end()

                // Trigger change to update PostNL times.
                .find('input[name*="city"]').trigger('change');
        } else {
            // Address not found, show manual input.
            this.element

                .find('.address-textual').addClass('tw-hidden').end()
                    .find('.address-manually')
                        .removeClass('tw-hidden')
                            .find('.not-found-message')
                                .removeClass('tw-hidden');
        }
    },

    showLoader() {
        this.element

            .find('.address-loader').removeClass('tw-hidden');
    },

    hideLoader() {
        this.element

            .find('.address-loader').addClass('tw-hidden');
    }

});
